module.exports = __webpack_public_path__ + "img/1.64d64a21.jpg";